import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { colors } from '../styles/shared.js';
import { t } from '../i18n.js';
import { cmdConfirmReset } from '../commands.js';

@customElement('confirm-reset-dialog')
export class ConfirmResetDialog extends LitElement {
  static styles = [
    colors,
    css`
      :host {
        position: absolute;
        inset: 0;
        pointer-events: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
      }
      .title {
        color: var(--color-white);
        font-size: 1.4rem;
      }
      .question {
        color: var(--color-cyan);
        font-size: 1.15rem;
      }
      .options {
        display: flex;
        gap: 2rem;
        margin-top: 0.5rem;
      }
      .option {
        position: relative;
        font-size: 1.15rem;
        cursor: pointer;
        padding: 0.5rem 1rem;
        user-select: none;
        color: var(--color-cyan);
      }
      @media (pointer: fine) {
        .option.selected::before {
          content: '\u25B8';
          position: absolute;
          right: 100%;
          margin-right: 0.3rem;
        }
      }
      kbd {
        font-family: inherit;
      }
    `,
  ];

  @property({ type: Number }) accessor selection = 0;

  render() {
    return html`
      <div class="title">${t('confirm-reset-title')}</div>
      <div class="question">${t('confirm-reset-question')}</div>
      <div class="options">
        <div
          class="option ${this.selection === 0 ? 'selected' : ''}"
          @click=${() => cmdConfirmReset(false)}
        ><kbd>N</kbd>o</div>
        <div
          class="option ${this.selection === 1 ? 'selected' : ''}"
          @click=${() => cmdConfirmReset(true)}
        ><kbd>Y</kbd>es</div>
      </div>
    `;
  }
}
